/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class TypeaheadHelperService {
    inputTextCodeNameFormatter = (x: { name: string, code: number }): string => {
        if (x == null) {
            return null;
        }
        if (typeof x === 'object') {
            return `${x.code} - ${x.name}`;
        }
    };

    inputTextNameFormatter = (x: { name: string }): string => {
        if (x == null) {
            return null;
        }
        if (typeof x === 'object') {
            return `${x.name}`;
        }
    };

    inputTextNumberDescriptionFormatter = (x: { number: string, description: string }): string => {
        if (x == null) {
            return null;
        }
        if (typeof x === 'object') {
            return `${x.number} - ${x.description}`;
        }
    };

    inputTextNumberVariationDescriptionFormatter = (x: { number: string, description: string }): string => {
        if (x == null) {
            return null;
        }
        if (typeof x === 'object') {
            return `${x.number?.split('-')[1]} - ${x.description}`;
        }
    };

    inputTextFirstNameLastNameUsernameFormatter = (x: { firstName: string, lastName: string, username: string }): string => {
        if (x == null) {
            return null;
        }
        if (typeof x === 'object' && x.username === null) {
            return `${x.firstName} ${x.lastName}`;
        }
        return `${x.firstName} ${x.lastName} (${x.username})`;
    };

    inputTextFormatter = (x: string): string => x;

}
